import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Paste your config here
const firebaseConfig = {
  apiKey: "AIzaSyAeuVHqoXCkuEvUU85ywZaA53RpPOXE61A",
  authDomain: "auth.outlne.com",
  projectId: "outlne-6a95c",
  storageBucket: "outlne-6a95c.firebasestorage.app",
  messagingSenderId: "860175423115",
  appId: "1:860175423115:web:28a0801a919906d036268e",
  measurementId: "G-EB13FY1R3V"
};





const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app, 'outlneappdb'); // 👈 ADD DATABASE ID HERE
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;

